import React,{Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Avatar} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import LocationMap from '../Deals/locationMap';
import { GetBusinessProfile } from '../../../Actions/businessProfineAction';
import { GetDeal } from '../../../Actions/dealActions';
import Loader from '../../../Helper/loader/loader';
import './Overview.css';

const styles = {
  divLine: {
    display: 'flex',
    justifyContent: 'center',
    padding: '5px 0 0'
  },
  friendCount:{
    borderTop: '1px solid #d6d6d6',
    width: '33.33%',
    borderRight: '1px solid #d6d6d6',
    padding: '5px 10px 0 15px'
  },
  followingCount:{
    borderTop: '1px solid #d6d6d6',
    width: '33.33%',
    padding: '5px 10px 0 15px'
  },
  divInline: {
    // display: 'flex'
    display: 'inline-flex',
    width: '100%',
    padding: '8px',
    verticalAlign:'middle'
  },
  divSpan: {
    borderLeft: '1px solid #9e9e9e3b',
    borderRight: '1px solid #9e9e9e3b'
  },
  right: {
    float: 'right'
  },
  dealOffer: {
    backgroundColor: '#e31836',
    textAlign: 'center',
    color: 'white',
    height: '210px',
    marginBottom: '10px'
  },
  bold:{
    fontWeight:700
  },
  margin:{
    marginLeft:'65px'
  },
  Color:{
   color:'#8b2388'
  }
}
class OverviewAppView extends Component{
  constructor() {
    super();
    this.state={
      latitude:'',
      longitude:''
    }
  }

  displayPhoneNo=(phoneno)=>{
    let no=phoneno.toString();
    return "(" + no.substring(0,3) + ") " + no.substring(3,6)+"-"+no.substring(6,no.length);
  };

  componentDidMount(){
    const {results}=this.props.user;

    this.props.GetDeal(results.BusinessUser.PlaceID);
    this.props.GetBusinessProfile(results.AppUser.UserId,results.AppUser.UserId,results.AppUser.Latitude,results.AppUser.Longitude);
  }

  checkColor=(points)=>{
    if(points<1000)
      return "points-under-1000";
    else if(points>=1000 && points<10000)
        return "points-greater-1000";
    else if(points>=10000 && points<50000)
      return "points-greater-10000";
    else if(points>=50000)
      return "points-greater-50000";
  };

  checkImgUrl=(url)=>{
    if(url=== null){
      let num= Math.floor((Math.random() * 4) + 1);
      return num
    }
  };

  checkProfileImg=(url)=>{
    const {businessProfile}=this.props;
      if(url=== null ){
        return <img
            className="profile-round-image"
            src={require(`../../../images/Alphabets/${this.props.user.results.AppUser.FirstName.match(/[a-z]/i)[0].toUpperCase()}.png`)}
        />
      }else{
        return  <img
            className="profile-round-image"
            src={businessProfile.ProfileDetail.ProfileImage}
        />
      }
  };
  render(){
    const {businessProfile,deals,user}=this.props;

    return(
        <React.Fragment>
        {(businessProfile.ProfileDetail) ?
          <div className="description-title">
            <div className="hovereffect-overview">
              <img
                  src={businessProfile.ProfileDetail.CoverImage!==null ?
                      businessProfile.ProfileDetail.CoverImage:
                      require(`../../../images/BusinessProfile/${this.checkImgUrl(businessProfile.ProfileDetail.CoverImage)}.jpg`)}
                  alt=""
                  className="overViewApp-cover-img"
              />
              <div className="round-profile-overview">
                <div>
                  <div>
                    <img
                        className="verified-img"
                        src={require(`../../../images/chek.png`)}
                    />
                  </div>
                  <div className="verified-text-heatspot">
                    Verified
                  </div>
                </div>
                <Avatar className="profile-avatar">
                  {this.checkProfileImg(businessProfile.ProfileDetail.ProfileImage)}
                </Avatar>
              </div>
            </div>
            <div className="bio">
              <div className={"profile-desc"}>
                <p className="profile-desc-status-text">{businessProfile.ProfileDetail.Bio}</p>
              </div>
            </div>
            <div className="content-table" />
            <div style={styles.divLine} className="content-table-div">
              <div style={styles.friendCount}>
                <p>{businessProfile.ProfileDetail.FriendCount}</p>
                <p>{'Friends'}</p>
              </div>
              <div style={styles.friendCount}>
                <p>{businessProfile.ProfileDetail.FollowerCount}</p>
                <p>{'Followers'}</p>
              </div>
              <div style={styles.followingCount}>
                <p>{businessProfile.ProfileDetail.FolloweingCount}</p>
                <p>{'Following'}</p>
              </div>
            </div>
            <div
                className="content-table-div"
                style={styles.divInline}
            >
              <div style={{
                width: '100%',
                display: 'inline-flex' }}
              >
                <div style={{ width: '50%' }}>
                  <span style={{
                    color: '#909090',
                    fontWeight: '500' }}
                  >
                    {'Rank:'}
                  </span>
                  <span style={{
                    marginLeft: '5px',
                    padding: '0 15px' }}
                        className={this.checkColor(businessProfile.ProfileDetail.Points)}
                  />
                </div>
                <div className="explorer-div">
                  <span className="explorer">{businessProfile.ProfileDetail.Rank}</span>
                  <span className="explorer">{` ${businessProfile.ProfileDetail.Points} Points`}</span>
                </div>
              </div>
            </div>
            {deals.BusinessDeal &&
              <div className="content-table-div">
                <div style={styles.dealOffer}
                     className="content-table-div"
                >
                  <div className="offer">
                    <h1>{deals.BusinessDeal && deals.BusinessDeal.Title}</h1>
                    <p>{deals.BusinessDeal && deals.BusinessDeal.Description}</p>
                    <p>{`expires:${deals.BusinessDeal && deals.BusinessDeal.EndDate && deals.BusinessDeal.EndDate.split(" ")[0]}`}</p>
                    </div>
                </div>
                <h6>{'Check In'}</h6>
                <h5>{`To claim deal, visit ${user.results.AppUser.FirstName} and tap "Check In" button above`}</h5>
              </div>
            }
            <div style={styles.divInline} className="content-table-div user-datail">
              <div className="overview-user-data">{'username'}</div>
              <div style={styles.margin}>{businessProfile.ProfileDetail.UserName}</div>
            </div>
            {(businessProfile.ProfileDetail.PhoneNumber && businessProfile.ProfileDetail.PhoneNumber!=="") &&
              <div
                  style={styles.divInline}
                  className="content-table-div">
                  <div className="overview-user-data">{'phone number'}</div>
                  <div className="overview-user-phonenumber" style={styles.margin}>
                    <span className={"phone-text"}>{this.displayPhoneNo(businessProfile.ProfileDetail.PhoneNumber)}</span>
                  </div>
              </div>
            }
            <div>
              <div className="content-table-div">
                <span className="overview-user-data" style={styles.Color}>{'Address'}</span>
              </div>
              <div style={{ marginTop: '10px' }}>
                <LocationMap
                    mapData={{ width:'385px',height:'200px'}}
                    user={this.props.user}
                    businessProfile={businessProfile.ProfileDetail}
                />
              </div>
              <div style={styles.divInline}>
                <div className="map-direction-to">{'Directions to here'}</div>
                <div className="map-direction-from">{'Directions from here'}</div>
              </div>
            </div>
          </div>
        :
        <div><Loader/></div>
      }
      </React.Fragment>
    )
  }
}
const mapStateToProps=(state)=> {
  return {
    businessProfile:state.businessProfile,
    deals:state.deals.results,
    user:state.loginResponse
  }
};
const matchDispatchToProps=(dispatch)=> {
  return bindActionCreators({
    GetBusinessProfile,
    GetDeal,
  },dispatch)
};
export default withStyles(styles)(connect(mapStateToProps,matchDispatchToProps)(OverviewAppView));